import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface CheckoutStoreState {
  tokenExists: boolean;
  payEType: boolean;
  tokenImgCardType: string;
  checkboxEnable: boolean;
  basketDetails: any;
  confirmBasketDetails: any;
  ccExpDate: string;
  selectedYear: string;
  selectedMonth: string;
  orderId: string;
}

export default {
  state: {
    tokenExists: false,
    payEType: false,
    tokenImgCardType: '',
    checkboxEnable: false,
    basketDetails: {},
    confirmBasketDetails: {},
    ccExpDate: '',
    selectedYear:'',
    selectedMonth:'',
    orderId:'',
  },
  actions: {
    updateBasketHeader(context: ActionContext<CheckoutStoreState , RootStoreState>, payload: any) {
      context.commit('startLoading', null , { root: true });
      const url = 'order/update-basket-header';
      return ApiServiceWrapper.post(url, payload);
    },
    completeOrder(context: ActionContext<CheckoutStoreState , RootStoreState>, payload: { request?: any, isfromBuyNow?:boolean } = { isfromBuyNow : false }) {
      context.commit('startLoading', null , { root: true });
      let completeRequest = { ...payload.request };
      if (!payload.isfromBuyNow) {
        completeRequest = {
          enccardetails: payload.request.encryptData,
          isPOOrder: true,
          paymentMode: payload.request.paymentMode,
          customerAddressId: payload.request.customerAddressId,
          isFound: payload.request.isFound };
      }
      const url = 'order/complete';
      return ApiServiceWrapper.post(url, completeRequest);
    },
    getOrderDetails(context: ActionContext<CheckoutStoreState , RootStoreState>, eOrderID: string) {
      context.commit('startLoading', null , { root: true });
      const url = `order/get?strEOrderID=${eOrderID}`;
      return ApiServiceWrapper.get(url);
    },
    getCountriesFromServer(context: ActionContext<CheckoutStoreState , RootStoreState>, isWCM: boolean = false) {
      context.commit('startLoading', null , { root: true });
      const wcmValue: string = isWCM ? 'YES' : 'NO';
      const url = `get-country?languageCode=EN&isWCM=${wcmValue}`;
      return ApiServiceWrapper.get(url);
    },
  },
  mutations: {
    mutate(state: any, payload: { property: any, with: any }) {
      state[payload.property] = payload.with;
    },
  },
  getters: {
    getSelectedYear: state => state.selectedYear,
    getSelectedMonth: state => state.selectedMonth,
    getTokenImgCardType: state => state.tokenImgCardType,
    getOrderIdFromQuote: state => state.orderId,
  },
  namespaced: true,
} as Module<CheckoutStoreState, RootStoreState>;
